import React, { useEffect, useState } from "react";
import NavLink from "components/NavLink";
import EmailSvg from "assets/images/svg/tile-email.svg";
import MobileSvg from "assets/images/svg/mobile.svg";
import { useFormattedMessage, useUtils } from "hooks";
import Checkbox from "components/Checkbox";
import { CLUB_DEAL_STATUS, UMBRELLA_STATUS } from "constants/status";
import { USER_ROLES, PHONE_TYPES } from "constants";
import { splitDateStringForProperDate, formateDate } from "utils";

const messages = {
    noInvestments: "no_investments",
    registrationIncomplete: "registration_incomplete",
    blocked: "blocked",
    tileLead: "registration_due",
    tileRegistering: "currrently_in_registration_process",
    tileActive: "active",
    tileBlocked: "status_blocked",
    statusApproved: "approved",
    statusRejected: "rejected",
    clubdeal: "club_deal",
};

const Tile = ({ user, onClick, selected, onClickCheckbox, isUmbrella, isTenant }) => {
    const { formatMessage } = useFormattedMessage();
    const tenantTechnicalName = useUtils().tenant.TechnicalName;

    const disabledTile =
        !isTenant && (user.StatusUserAccount != "active" || user.UserRegistrationOnboardingStatus != "registrationSuccess");

    const isUserHasClubDeal = !!user?.Roles?.find((role) => {
        if (isTenant) return role === `${tenantTechnicalName}.${USER_ROLES.CLUBDEALS}`;
        return role.search(USER_ROLES.CLUBDEALS) > -1;
    });
    const isUserClubDealOnboardingCompleted = user.StatusClubDeal === CLUB_DEAL_STATUS.COMPLETED;
    const isUserClubDealCompleted = isUserHasClubDeal && isUserClubDealOnboardingCompleted;

    const [userPhone, setUserPhone] = useState();

    const createNameAcronym = (_fname, _lname, _email) => {
        if (_fname && _lname) {
            return _fname.charAt(0) + _lname.charAt(0);
        }

        if (_fname) {
            return _fname.charAt(0) + _fname.charAt(_fname.length - 1);
        }

        if (_lname) {
            return _lname.charAt(0) + _lname.charAt(_lname.length - 1);
        }

        if (_email) {
            return _email.charAt(0) + _email.charAt(1);
        }
        return "";
    };

    const username = (_fname, _lname, _email) => {
        if (_fname || _lname) {
            const _fullName = _fname + " " + _lname;
            const _subText = _fullName.slice(0, 20);
            return _fullName.length > 50 ? _subText + "..." : _subText;
        }

        if (_email) {
            const _subText = _email.slice(0, 20);
            return _email.length > 50 ? _subText + "..." : _subText;
        }
        return false;
    };

    const checkboxTile = (_onBoardingStatus, _statusUserAcc, _leadStatus, _statusUmbrellaClearance) => {
        if (isUmbrella) {
            if (_statusUmbrellaClearance === UMBRELLA_STATUS.APPROVED) {
                return <div className="fw-500 text-12 status-text">{formatMessage(messages.statusApproved)}</div>;
            } else if (_statusUmbrellaClearance === UMBRELLA_STATUS.REJECTED) {
                return (
                    <div className="fw-500 text-12 danger-red-color status-text">{formatMessage(messages.statusRejected)}</div>
                );
            } else {
                return (
                    <div
                        onClick={(e) => {
                            return e.stopPropagation();
                        }}
                        className="flex-row align-center"
                    >
                        <Checkbox
                            inputIdon={user.uid}
                            name={user.uid}
                            size="small"
                            className="mb-3"
                            value={selected}
                            onChange={() => {
                                onClickCheckbox(user.uid, !selected, username(user.FirstName, user.LastName, user.Email));
                            }}
                        />
                    </div>
                );
            }
        } else if (_leadStatus === "Lead") {
            return (
                <div>
                    <span className="fw-500 text-12 mb-3">
                        {!!user?.UserStateChangeDate
                            ? formateDate(
                                  new Date(...splitDateStringForProperDate(user?.UserStateChangeDate)),
                                  "date",
                                  "month",
                                  "year",
                                  "."
                              )
                            : ""}
                    </span>
                    <div className="fw-500 text-12 status-text">{formatMessage(messages.tileLead)}</div>
                </div>
            );
        } else if (_statusUserAcc === "deactivate") {
            return (
                <div>
                    <span className="fw-500 text-12 mb-3">
                        {!!user?.UserStateChangeDate
                            ? formateDate(
                                  new Date(...splitDateStringForProperDate(user?.UserStateChangeDate)),
                                  "date",
                                  "month",
                                  "year",
                                  "."
                              )
                            : ""}
                    </span>
                    <div className="fw-500 text-12 status-text">{formatMessage(messages.tileBlocked)}</div>
                </div>
            );
        } else if (_onBoardingStatus === "registrationSuccess") {
            return (
                <div>
                    <div
                        className="d-flex align-center"
                        onClick={(e) => {
                            return e.stopPropagation();
                        }}
                    >
                        <span className="fw-500 text-12 mr-2 mb-3">
                            {!!user?.UserStateChangeDate
                                ? formateDate(
                                      new Date(...splitDateStringForProperDate(user?.UserStateChangeDate)),
                                      "date",
                                      "month",
                                      "year",
                                      "."
                                  )
                                : ""}
                        </span>
                        <Checkbox
                            inputId={user.uid}
                            name={user.uid}
                            size="small"
                            className="mb-3"
                            value={selected}
                            values
                            onChange={() => {
                                onClickCheckbox(user.uid, !selected);
                            }}
                        />
                    </div>
                    <div className="fw-500 text-12 status-text">{formatMessage(messages.tileActive)}</div>
                </div>
            );
        } else {
            return (
                <div>
                    <span className="fw-500 text-12 mb-3">
                        {!!user?.UserStateChangeDate
                            ? formateDate(
                                  new Date(...splitDateStringForProperDate(user?.UserStateChangeDate)),
                                  "date",
                                  "month",
                                  "year",
                                  "."
                              )
                            : ""}
                    </span>
                    <div className="fw-500 text-12 status-text">{formatMessage(messages.tileRegistering)}</div>
                </div>
            );
        }
    };

    useEffect(() => {
        const phoneNumber = user?.Phone?.find(
            (phone) => phone.TypePhone == PHONE_TYPES.TypePhoneMobile && !!phone?.Number && !!phone?.DialCode
        );
        phoneNumber && setUserPhone(phoneNumber);
    }, [user]);

    return (
        <div
            className={`list-card user-list-card d-flex border-1 border-radius my-5 cursor-pointer ${
                selected ? "selected-row" : ""
            }`}
            onClick={() => onClick(user)}
        >
            <div
                className={`name-initial d-flex justify-center align-center bg-lighter-grey ${
                    disabledTile ? "quarter-opacity" : ""
                }`}
            >
                <span className="bg-dark text-22 text-uppercase d-flex justify-center align-center">
                    {createNameAcronym(user.FirstName, user.LastName, user.Email) || "---"}
                </span>
            </div>
            <div className="d-flex justify-between main-details-block">
                <div className={`detail-block d-flex ${disabledTile ? "quarter-opacity" : ""}`}>
                    <div className="flex-column w-100">
                        <div className="text-14 fw-600 mb-3 user-title">
                            {username(user.FirstName, user.LastName, user.Email) || "-------------------------"}
                        </div>
                        <div className="flex w-90 align-center contact-links">
                            {isTenant && isUserClubDealCompleted ? (
                                <span
                                    style={{ borderColor: "#9E9FA4" }}
                                    className="mr-4 text-12 tag fw-500 d-inline-block cursor-unset"
                                >
                                    {formatMessage(messages.clubdeal)}
                                </span>
                            ) : null}
                            <NavLink
                                className="email-icon"
                                onClick={(e) => {
                                    return e.stopPropagation();
                                }}
                                href={`mailto: ${user.Email}`}
                                passHref
                            >
                                <span>
                                    <EmailSvg />
                                </span>
                            </NavLink>
                            {userPhone && (
                                <NavLink
                                    onClick={(e) => {
                                        return e.stopPropagation();
                                    }}
                                    Link
                                    href={`tel: +${userPhone.DialCode + userPhone.Number}`}
                                    passHref
                                >
                                    <span>
                                        <MobileSvg />
                                    </span>
                                </NavLink>
                            )}
                        </div>
                    </div>
                </div>

                {/* <div className={`flex w-30 ${disabledTile ? "quarter-opacity" : ""}`}>
				{investmentTile(user.investments, user.UserRegistrationOnboardingStatus, user.StatusUserAccount)}
			</div> */}
                <div className="checkbox-container pr-4 position-relative">
                    {checkboxTile(
                        user.UserRegistrationOnboardingStatus,
                        user.StatusUserAccount,
                        user.TypePerson,
                        user.StatusUmbrellaClearance
                    )}
                </div>
            </div>
        </div>
    );
};

export default Tile;
